"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_NamingSystem_UniqueId = exports.NamingSystem_UniqueIdTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Period_1 = require("./RTTI_Period");
var NamingSystem_UniqueIdTypeKind;
(function (NamingSystem_UniqueIdTypeKind) {
    NamingSystem_UniqueIdTypeKind["_oid"] = "oid";
    NamingSystem_UniqueIdTypeKind["_uuid"] = "uuid";
    NamingSystem_UniqueIdTypeKind["_uri"] = "uri";
    NamingSystem_UniqueIdTypeKind["_other"] = "other";
})(NamingSystem_UniqueIdTypeKind = exports.NamingSystem_UniqueIdTypeKind || (exports.NamingSystem_UniqueIdTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_NamingSystem_UniqueId = t.recursion('INamingSystem_UniqueId', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        type: (0, EnumType_1.createEnumType)(NamingSystem_UniqueIdTypeKind, 'NamingSystem_UniqueIdTypeKind'),
        _type: RTTI_Element_1.RTTI_Element,
        value: t.string,
        _value: RTTI_Element_1.RTTI_Element,
        preferred: t.boolean,
        _preferred: RTTI_Element_1.RTTI_Element,
        comment: t.string,
        _comment: RTTI_Element_1.RTTI_Element,
        period: RTTI_Period_1.RTTI_Period
    });
});
//# sourceMappingURL=RTTI_NamingSystem_UniqueId.js.map